<template>
  <div class="container">
    <h3 class="title">
      Sprawa jest w trakcie rejestrowania.
      <br />Za chwilę dostaniesz jej numer.
      <br />
      <br />
      Zgłoszenie zostało przyjęte pod numerem {{itemNumber}}.
      <br />W ciągu trzydziestu minut otrzymasz informację odnośnie statusu zgłoszenia.
    </h3>
    <div class="btn-group">
      <button type="button" class="btn" :style="{ background: $color }" @click="setHomePage">MENU</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "DataSent",
  methods: {
    ...mapMutations(["setHomePage"]),
  },
  computed: {
    ...mapState(["itemNumber"]),
  },
};
</script>

<style scoped lang="scss">
.text {
  margin-top: 16px;
  color: #454545;
  font-size: 14px;
  line-height: 25px;
  padding-right: 16px;
  span {
    margin-top: 8px;
    display: block;
  }
}
.result {
  display: flex;
}
.container {
  width: 895px;
}
.btn {
  margin: 0;
}
.btn-group {
  margin-top: 24px;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/DataSent.vue